var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "q-side" } },
    [
      _c(
        "q-stepper",
        { ref: "stepper2", attrs: { color: "purple-13", vertical: "" } },
        [
          _c(
            "q-step",
            {
              attrs: {
                default: "",
                name: "pricings",
                title: "create your order:",
                subtitle: ""
              }
            },
            [
              _c(
                "div",
                { staticClass: "sidebar_pricing_cont" },
                [
                  _vm.pricingOpts.length > 1
                    ? _c("q-select", {
                        attrs: {
                          color: "gray-4",
                          separator: "",
                          options: _vm.pricingOpts,
                          suffix: _vm.fM(
                            _vm.pricingOpts[_vm.selectPricing - 1][
                              "pricing_amount"
                            ],
                            _vm.pricingOpts[_vm.selectPricing - 1][
                              "pricing_currency"
                            ]
                          )
                        },
                        on: { input: _vm.callPum, change: _vm.onChangePricing },
                        model: {
                          value: _vm.selectPricing,
                          callback: function($$v) {
                            _vm.selectPricing = $$v
                          },
                          expression: "selectPricing"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.pricingOpts.length === 1
                    ? _c("q-field", [
                        _c("span", [
                          _vm._v(
                            "\n                  " +
                              _vm._s(
                                _vm.pricingOpts[_vm.selectPricing - 1]["label"]
                              ) +
                              "\n                "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass:
                              "q-if-addon q-if-addon-visible pull-right"
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.fM(
                                    _vm.pricingOpts[_vm.selectPricing - 1][
                                      "pricing_amount"
                                    ],
                                    _vm.pricingOpts[_vm.selectPricing - 1][
                                      "pricing_currency"
                                    ]
                                  )
                                ) +
                                "\n                "
                            )
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.pricingOpts[_vm.selectPricing - 1][
                    "pricing_description"
                  ] &&
                  _vm.pricingOpts[_vm.selectPricing - 1][
                    "pricing_description"
                  ].trim().length
                    ? _c(
                        "q-collapsible",
                        {
                          staticClass: "sidebar_pricing_description",
                          attrs: { opened: "", label: "Description" }
                        },
                        [
                          _c("div", [
                            _c("p", { staticClass: "snote" }, [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(
                                    _vm.pricingOpts[_vm.selectPricing - 1][
                                      "pricing_description"
                                    ]
                                  ) +
                                  "\n                    "
                              )
                            ])
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.pricingOpts[_vm.selectPricing - 1]["pricing_type"] ==
                  "variable"
                    ? _c("p", { staticClass: "sidebar_pricing_variable" })
                    : _vm._e(),
                  _c("hr", { staticClass: "umHr" }),
                  _vm._v(" "),
                  _vm.striX(_vm.pricingOpts[_vm.selectPricing - 1]["pum"])
                    ? _c(
                        "p",
                        { staticClass: "sidebar_pricing_pum" },
                        [
                          _c("span", [_vm._v("Order")]),
                          _vm._v(" "),
                          _c("q-input", {
                            staticClass: "umInput",
                            attrs: {
                              type: "number",
                              min: _vm.pum_min(),
                              max: _vm.pum_max(),
                              "float-label": "*multiplies the final price"
                            },
                            model: {
                              value: _vm.pumQuantity,
                              callback: function($$v) {
                                _vm.pumQuantity = $$v
                              },
                              expression: "pumQuantity"
                            }
                          }),
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm.pricingOpts[_vm.selectPricing - 1]["pum"]
                              ) +
                              "\n                           "
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.striX(_vm.pricingOpts[_vm.selectPricing - 1]["sum"])
                    ? _c(
                        "p",
                        { staticClass: "sidebar_pricing_sum" },
                        [
                          _c("span", [_vm._v("Order")]),
                          _vm._v(" "),
                          _c("q-input", {
                            staticClass: "umInput",
                            attrs: {
                              type: "number",
                              min: _vm.sum_min(),
                              max: _vm.sum_max(),
                              "float-label": "*multiplies the final price"
                            },
                            model: {
                              value: _vm.sumQuantity,
                              callback: function($$v) {
                                _vm.sumQuantity = $$v
                              },
                              expression: "sumQuantity"
                            }
                          }),
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm.pricingOpts[_vm.selectPricing - 1]["sum"]
                              ) +
                              "\n                           "
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("p"),
                  _vm._v(" "),
                  _vm.pricingOpts[_vm.selectPricing - 1]["pricing_type"] ==
                  "variable"
                    ? _c(
                        "p",
                        { staticClass: "sidebar_pricing_description snote" },
                        [
                          _vm._v(
                            "\n                The price of " +
                              _vm._s(
                                _vm.pricingOpts[_vm.selectPricing - 1][
                                  "pricing_amount"
                                ]
                              ) +
                              " " +
                              _vm._s(
                                _vm.pricingOpts[_vm.selectPricing - 1][
                                  "pricing_currency"
                                ].toUpperCase()
                              ) +
                              " will be multiplied\n                by number of selected " +
                              _vm._s(
                                _vm.pricingOpts[_vm.selectPricing - 1]["pum"]
                              ) +
                              "(s).\n            "
                          ),
                          parseInt(
                            _vm.pricingOpts[_vm.selectPricing - 1]["pum_min"]
                          )
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.pricingOpts[_vm.selectPricing - 1][
                                      "pum_min"
                                    ]
                                  ) +
                                    " " +
                                    _vm._s(
                                      _vm.pricingOpts[_vm.selectPricing - 1][
                                        "pum"
                                      ]
                                    ) +
                                    "(s) is minimum. "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          parseInt(
                            _vm.pricingOpts[_vm.selectPricing - 1]["pum_max"]
                          )
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.pricingOpts[_vm.selectPricing - 1][
                                      "pum_max"
                                    ]
                                  ) +
                                    " " +
                                    _vm._s(
                                      _vm.pricingOpts[_vm.selectPricing - 1][
                                        "pum"
                                      ]
                                    ) +
                                    "(s) is maximum. "
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.pricingOpts[_vm.selectPricing - 1]["pricing_type"] ==
                    "variable" &&
                  _vm.striX(_vm.pricingOpts[_vm.selectPricing - 1]["sum"])
                    ? _c(
                        "p",
                        { staticClass: "sidebar_pricing_description snote" },
                        [
                          _vm._v(
                            "\n                The price of " +
                              _vm._s(
                                _vm.pricingOpts[_vm.selectPricing - 1][
                                  "pricing_amount"
                                ]
                              ) +
                              " " +
                              _vm._s(
                                _vm.pricingOpts[_vm.selectPricing - 1][
                                  "pricing_currency"
                                ].toUpperCase()
                              ) +
                              " will be multiplied\n                by number of selected " +
                              _vm._s(
                                _vm.pricingOpts[_vm.selectPricing - 1]["sum"]
                              ) +
                              "(s).\n\n            "
                          ),
                          parseInt(
                            _vm.pricingOpts[_vm.selectPricing - 1]["sum_min"]
                          )
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.pricingOpts[_vm.selectPricing - 1][
                                      "sum_min"
                                    ]
                                  ) +
                                    " " +
                                    _vm._s(
                                      _vm.pricingOpts[_vm.selectPricing - 1][
                                        "sum"
                                      ]
                                    ) +
                                    "(s) is minimum. "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          parseInt(
                            _vm.pricingOpts[_vm.selectPricing - 1]["sum_max"]
                          )
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.pricingOpts[_vm.selectPricing - 1][
                                      "sum_max"
                                    ]
                                  ) +
                                    " " +
                                    _vm._s(
                                      _vm.pricingOpts[_vm.selectPricing - 1][
                                        "sum"
                                      ]
                                    ) +
                                    "(s) is maximum. "
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.pricingOpts[_vm.selectPricing - 1]["pricing_type"] ==
                    "variable" &&
                  (parseInt(
                    _vm.pricingOpts[_vm.selectPricing - 1]["pum_min"]
                  ) ||
                    parseInt(_vm.pricingOpts[_vm.selectPricing - 1]["sum_min"]))
                    ? _c(
                        "p",
                        { staticClass: "sidebar_pricing_description snote" },
                        [
                          _vm._v("\n                Selecting at least "),
                          parseInt(
                            _vm.pricingOpts[_vm.selectPricing - 1]["pum_min"]
                          )
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.pricingOpts[_vm.selectPricing - 1][
                                      "pum_min"
                                    ]
                                  ) +
                                    " " +
                                    _vm._s(
                                      _vm.pricingOpts[_vm.selectPricing - 1][
                                        "pum"
                                      ]
                                    ) +
                                    "(s)"
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          parseInt(
                            _vm.pricingOpts[_vm.selectPricing - 1]["pum_min"]
                          )
                            ? _c("span", [
                                _vm._v(
                                  "or " +
                                    _vm._s(
                                      _vm.pricingOpts[_vm.selectPricing - 1][
                                        "sum_min"
                                      ]
                                    ) +
                                    _vm._s(
                                      _vm.pricingOpts[_vm.selectPricing - 1][
                                        "sum"
                                      ]
                                    ) +
                                    "(s) "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" is required\n            ")
                        ]
                      )
                    : _c(
                        "p",
                        { staticClass: "sidebar_pricing_description snote" },
                        [
                          _vm._v(
                            "\n                Price: " +
                              _vm._s(
                                _vm.pricingOpts[_vm.selectPricing - 1][
                                  "pricing_amount"
                                ]
                              ) +
                              " " +
                              _vm._s(
                                _vm.pricingOpts[_vm.selectPricing - 1][
                                  "pricing_currency"
                                ].toUpperCase()
                              ) +
                              "\n            "
                          )
                        ]
                      ),
                  _vm._v(" "),
                  _vm.pricingOpts[_vm.selectPricing - 1]["pricing_type"] ==
                    "variable" &&
                  _vm.pricingOpts[_vm.selectPricing - 1]["pricing_days"] >= 1
                    ? _c(
                        "p",
                        { staticClass: "sidebar_pricing_description snote" },
                        [
                          _vm._v(
                            "\n                This pricing option requires " +
                              _vm._s(
                                _vm.pricingOpts[_vm.selectPricing - 1][
                                  "pricing_days"
                                ]
                              ) +
                              " days for fulfillment\n            "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.$v.eitherUm
                    ? _c(
                        "p",
                        {
                          class: {
                            error: true,
                            rerror: _vm.submitStatus === "ERROR"
                          }
                        },
                        [_vm._v("Enter at least one unit of measure!")]
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.termOpts.length || _vm.extraOpts.length
                ? _c(
                    "q-stepper-navigation",
                    [
                      _c(
                        "q-btn",
                        {
                          staticStyle: { left: "180px" },
                          attrs: {
                            color: "green-6",
                            disabled: this.$v.$invalid
                          },
                          on: {
                            click: function($event) {
                              _vm.$refs.stepper2.next((_vm.step = 2))
                            }
                          }
                        },
                        [_vm._v("Next")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.termOpts.length
            ? _c(
                "q-step",
                {
                  attrs: {
                    name: "terms",
                    icon: "attach_money",
                    title: "Choose terms and conditions:",
                    subtitle: ""
                  }
                },
                [
                  _vm.termOpts.length
                    ? _c(
                        "div",
                        { staticClass: "sidebar_term_cont" },
                        [
                          _vm.termOpts.length > 1
                            ? _c("q-select", {
                                attrs: {
                                  color: "gray-4",
                                  separator: "",
                                  options: _vm.termOpts
                                },
                                model: {
                                  value: _vm.selectTerm,
                                  callback: function($$v) {
                                    _vm.selectTerm = $$v
                                  },
                                  expression: "selectTerm"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.termOpts.length === 1
                            ? _c("q-field", [
                                _c("span", [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.termOpts[_vm.selectTerm - 1][
                                          "label"
                                        ]
                                      ) +
                                      "\n              "
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.termOpts
                            ? _c(
                                "p",
                                { staticClass: "sidebar_pricing_description" },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.termOpts[_vm.selectTerm - 1][
                                          "terms_description"
                                        ]
                                      ) +
                                      "\n            "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.termOpts &&
                          _vm.termOpts[_vm.selectTerm - 1]["terms_days"] &&
                          parseInt(
                            _vm.termOpts[_vm.selectTerm - 1]["terms_days"],
                            10
                          ) > 0
                            ? _c(
                                "p",
                                {
                                  staticClass:
                                    "sidebar_pricing_description snote"
                                },
                                [
                                  _vm._v(
                                    "\n                            Choosing this option will prolong the delivery for " +
                                      _vm._s(
                                        _vm.termOpts[_vm.selectTerm - 1][
                                          "terms_days"
                                        ]
                                      ) +
                                      " days;\n            "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "q-stepper-navigation",
                    [
                      _c(
                        "q-btn",
                        {
                          attrs: { color: "grey-6" },
                          on: {
                            click: function($event) {
                              _vm.$refs.stepper2.previous((_vm.step = 1))
                            }
                          }
                        },
                        [_vm._v("Back")]
                      ),
                      _vm._v(" "),
                      _vm.extraOpts.length
                        ? _c(
                            "q-btn",
                            {
                              staticStyle: { left: "100px" },
                              attrs: { color: "green-6" },
                              on: {
                                click: function($event) {
                                  _vm.$refs.stepper2.next((_vm.step = 3))
                                }
                              }
                            },
                            [_vm._v("Next")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.extraOpts.length
            ? _c(
                "q-step",
                {
                  attrs: {
                    name: "extras",
                    icon: "add",
                    title: "select extras:",
                    subtitle: ""
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "sidebar_extra_cont" },
                    [
                      _vm.extraOpts.length > 1
                        ? _c(
                            "ul",
                            { attrs: { id: "extra-checkbox-group" } },
                            _vm._l(_vm.extraOpts, function(extra, index) {
                              return _c(
                                "li",
                                { key: index },
                                [
                                  _c("q-checkbox", {
                                    attrs: {
                                      val: extra.value,
                                      label: extra.label
                                    },
                                    model: {
                                      value: _vm.checkExtra,
                                      callback: function($$v) {
                                        _vm.checkExtra = $$v
                                      },
                                      expression: "checkExtra"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "q-if-addon q-if-addon-visible pull-right extra-percent"
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            "+ " + extra.extras_percent + " %"
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  extra.extras_days &&
                                  parseInt(extra.extras_days, 10) > 0
                                    ? _c(
                                        "p",
                                        {
                                          staticClass:
                                            "sidebar_pricing_description snote"
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Choosing this option will prolong the delivery for " +
                                              _vm._s(extra.extras_days) +
                                              " days\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "q-collapsible",
                                    {
                                      staticClass:
                                        "extra_desc sidebar_pricing_description",
                                      attrs: { label: "Description" }
                                    },
                                    [
                                      _c("div", [
                                        _c("p", { staticClass: "snote" }, [
                                          _vm._v(
                                            "\n                        " +
                                              _vm._s(extra.extras_description) +
                                              "\n                    "
                                          )
                                        ])
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            })
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.extraOpts.length === 1
                        ? _c("q-field", [
                            _c(
                              "span",
                              [
                                _c("q-checkbox", {
                                  attrs: {
                                    val: _vm.extraOpts[0].value,
                                    label: _vm.extraOpts[0].label
                                  },
                                  model: {
                                    value: _vm.checkExtra,
                                    callback: function($$v) {
                                      _vm.checkExtra = $$v
                                    },
                                    expression: "checkExtra"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "q-if-addon q-if-addon-visible pull-right extra-percent"
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          "+ " +
                                            _vm.extraOpts[0].extras_percent +
                                            " %"
                                        ) +
                                        "\n                "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.extraOpts[0].extras_days &&
                                parseInt(_vm.extraOpts[0].extras_days, 10) > 0
                                  ? _c(
                                      "p",
                                      {
                                        staticClass:
                                          "sidebar_pricing_description snote"
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Choosing this option will prolong the delivery for " +
                                            _vm._s(
                                              _vm.extraOpts[0].extras_days
                                            ) +
                                            " days\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "q-stepper-navigation",
                    [
                      _c(
                        "q-btn",
                        {
                          attrs: { color: "grey-6" },
                          on: {
                            click: function($event) {
                              _vm.$refs.stepper2.previous((_vm.step = 2))
                            }
                          }
                        },
                        [_vm._v("Back")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      this.$v.$invalid
        ? _c("p", { staticClass: "error rerror" }, [
            _vm._v("Please fill the form correctly.")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "q-btn",
        {
          class: {
            "full-width": true,
            rerror: _vm.submitStatus === "ERROR",
            active: _vm.step >= _vm.stepsCount ? "active" : ""
          },
          attrs: {
            color: "green-6",
            size: "lg",
            label: "Full-width",
            disabled: this.$v.$invalid,
            suffix: _vm.calcPrice()
          },
          on: { click: _vm.order }
        },
        [
          _vm._v(
            "Submit Order - " +
              _vm._s(
                _vm.fM(
                  _vm.calcPrice(),
                  _vm.pricingOpts[_vm.selectPricing - 1]["pricing_currency"]
                )
              )
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/App.vue
// module id = 86
// module chunks = 1